import actions from './actions';
import { onLoadMultiDaySuccess } from '../common/reducers';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  jobs: [],
  loading: false,
  total: 0,
  filteredTotal: 0,
  jobGroup: null,
  assignModalVisible: false,
  assignModalData: [],
  modalDataLoading: false,
  job: null,
  search: {},
};

function onLoadData(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadDataSuccess(state, { payload }) {
  const { data, total, filteredTotal, jobGroup, filters, search } = payload;
  // Add additional children an empty array for Multi Days jobs to indicate expandable row in the table
  const jobs = data.map(record => {
    return record.multi_day ? { ...record, children: [] } : record;
  });

  return {
    ...state,
    jobs,
    total,
    filteredTotal,
    jobGroup,
    loading: false,
    filters,
    search,
  };
}

function onShowAssignModal(state, { payload }) {
  return { ...state, assignModalVisible: true, job: payload };
}

function onHideAssignModal(state) {
  return { ...state, assignModalVisible: false, job: null };
}

function onAssignModalLoadData(state) {
  return { ...state, modalDataLoading: true, assignModalData: [] };
}

function onAssignModalLoadDataSuccess(state, { payload }) {
  return { ...state, modalDataLoading: false, assignModalData: payload };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoadData,
  [actions.LOAD_SUCCESS]: onLoadDataSuccess,
  [actions.LOAD_MULTI_DAY_SUCCESS]: onLoadMultiDaySuccess,
  [actions.SHOW_ASSIGN_MODAL]: onShowAssignModal,
  [actions.HIDE_ASSIGN_MODAL]: onHideAssignModal,
  [actions.ASSIGN_MODAL_LOAD_DATA]: onAssignModalLoadData,
  [actions.ASSIGN_MODAL_LOAD_DATA_SUCCESS]: onAssignModalLoadDataSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
